import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

export default function EditCertificate() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    description: "",
    gst: "",
    days: "",
    aboutCourse: "",
    eligibility: "",
    courseIncludes: "",
    courseExcludes: "",
    mainImage: null,
    galleryImages: [],
  });

  const [existingImages, setExistingImages] = useState({
    main: null,
    gallery: [],
  });

  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
        const token = adminInfo?.token;

        const res = await fetch(`${API_BASE_URL}/api/certificates/${id}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!res.ok) throw new Error("Certificate not found");
        const data = await res.json();

        const arrToText = (arr) => Array.isArray(arr) ? arr.join("\n") : arr || "";

        setFormData({
          name: data.name || "",
          price: data.price || "",
          description: data.description || "",
          gst: data.gst || "",
          days: data.days || "",
          aboutCourse: data.aboutCourse || "",
          eligibility: arrToText(data.eligibility),
          courseIncludes: arrToText(data.courseIncludes),
          courseExcludes: arrToText(data.courseExcludes),
          mainImage: null,
          galleryImages: [],
        });

        setExistingImages({
          main: data.images?.main || data.image || null,
          gallery: data.images?.gallery || [],
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificate();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "mainImage" && files?.length) {
      setFormData((prev) => ({ ...prev, mainImage: files[0] }));
    } else if (name === "galleryImages") {
      setFormData((prev) => ({ ...prev, galleryImages: Array.from(files) }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
      const token = adminInfo?.token;
      const data = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (!value) return;
        if (key === "galleryImages") {
          value.forEach((img) => data.append("galleryImages", img));
        } else {
          data.append(key, value);
        }
      });

      const res = await fetch(`${API_BASE_URL}/api/certificates/${id}`, {
        method: "PUT",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: data,
      });

      if (!res.ok) throw new Error("Update failed");

      alert("✅ Certificate updated successfully");
      navigate("/admin/certificates");
    } catch (err) {
      alert(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getMainPreview = () => {
    if (formData.mainImage) return URL.createObjectURL(formData.mainImage);
    if (existingImages.main) return `${API_BASE_URL}${existingImages.main}`;
    return null;
  };

  if (loading) return (
    <div className="admin-list-container">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
        <div className="loading-spinner"></div>
        <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Syncing Resource Data Matrix...</p>
      </div>
    </div>
  );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Update Resource</h1>
        </div>
        <div className="module-badge" style={{ background: '#d946ef' }}>Edit Mode</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-form-card">
          <form className="admin-form-elite" onSubmit={handleSubmit}>
            <label>
              Certificate Name
              <input name="name" value={formData.name} onChange={handleChange} required />
            </label>

            <label>
              Price (INR)
              <input type="number" name="price" value={formData.price} onChange={handleChange} required />
            </label>

            <label className="full-width-field">
              Short Description
              <textarea name="description" value={formData.description} onChange={handleChange} required />
            </label>

            <label>
              GST
              <input name="gst" value={formData.gst} onChange={handleChange} required />
            </label>

            <label>
              Duration (Days)
              <input type="number" name="days" value={formData.days} onChange={handleChange} required />
            </label>

            <label className="full-width-field">
              About Certificate
              <textarea name="aboutCourse" value={formData.aboutCourse} onChange={handleChange} />
            </label>

            <label className="full-width-field">
              Eligibility
              <textarea name="eligibility" value={formData.eligibility} onChange={handleChange} />
            </label>

            <label>
              Includes
              <textarea name="courseIncludes" value={formData.courseIncludes} onChange={handleChange} />
            </label>

            <label>
              Excludes
              <textarea name="courseExcludes" value={formData.courseExcludes} onChange={handleChange} />
            </label>

            <label>
              Replace Main Image
              <input type="file" name="mainImage" accept="image/*" onChange={handleChange} />
            </label>

            <label>
              Replace Gallery
              <input type="file" name="galleryImages" accept="image/*" multiple onChange={handleChange} />
            </label>

            {getMainPreview() && (
              <div className="img-preview-box">
                <img src={getMainPreview()} alt="preview" className="preview-thumb" />
              </div>
            )}

            <div className="admin-submit-area">
              <button className="btn-primary-elite" disabled={isSubmitting}>
                {isSubmitting ? "Saving Changes..." : "Sync Updates"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
